import React, { useEffect, useRef }  from 'react';
import classes from './DynamicPagePromos.module.scss';
import { getFileName } from 'helpers/FileCaching';
import globalJson from 'data/content.json';
import ScrollMagic from 'scrollmagic';
import TimelineMax from "gsap/TimelineMax";
import {TweenMax, Power3, Power2} from 'gsap';

const promosImages = require.context('assets/images/DynamicPagePromos', true, /.*\.(gif|png|jpe?g|svg)$/i);
const iconsImages = require.context('assets/images/global/icons', true, /.*\.(gif|png|jpe?g|svg)$/i);
const DynamicPagePromos = ({content, history, carRef}) => {

    //Timeline variables
    let container = useRef();
    let promosMoveCont = useRef();
    let promosMove = useRef([]);

    let btnPromoOnHover = useRef();
    let btnPromoArrowOnHover = useRef();
    let btnPromoOvalOnHover = useRef();
    let promoImage = useRef();
   

    //Configure scroll magic
    let scrollMagicController = useRef(new ScrollMagic.Controller())
    let scrollMagicScene = useRef(new ScrollMagic.Scene({
                                    triggerHook:0.7
                                }).addTo(scrollMagicController.current)
                            )

    let showAll_tl = useRef(new TimelineMax({paused:true}));
    showAll_tl.current.timeScale(2);

  
    const configureScrollMagic = () => {
        scrollMagicScene.current.triggerElement(promosMoveCont.current);
        scrollMagicScene.current.duration((promosMoveCont.current.clientHeight));
        scrollMagicScene.current.triggerHook(0.7);
        scrollMagicScene.current.reverse(false);
        scrollMagicScene.current.on("progress", function(event){
            updateTimeline(event.progress);
        })
    }

  
    const createTimeline = () => {
        showAll_tl.current.fromTo(promosMoveCont.current,  0.5, {delay: 3, opacity:0, y:90},{opacity:1, y:0, ease: Power3.easeInOut});
        showAll_tl.current.staggerFromTo(promosMove.current, 1,{opacity:0, y:30 }, {opacity:1, y:0 }, 0.5);

    }

    const updateTimeline = (progress) => {
        let timelineLength = showAll_tl.current.duration();
        let tweenToSeconds = timelineLength*progress
        showAll_tl.current.tweenTo(tweenToSeconds);
    }


    useEffect(() => {
        createTimeline();
        configureScrollMagic();
      
    }, []);


    const onPromoClick = (title) =>{
        window.gtag('event', "Episode clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': title+ " Episode clicked",
			'value':10
          });
    }

    const goToArticle = (url) => {
        history.push(url)
    }
  

    function overPromo(index){
        TweenMax.fromTo('.AA-'+ index, 0.2, {scale:1}, { delay: 0, scale:0.7, ease: Power3.easeInOut});
        TweenMax.fromTo( '.BB-'+ index, 0.2, {css:{height:0, width: 0}}, { delay: 0, css:{height:30, width: 30}, ease: Power3.easeInOut});
    }
    function outPromo(index){
        TweenMax.to('.AA-'+ index, 0.2, {scale:1, ease: Power3.easeInOut})
        TweenMax.to('.BB-'+ index, 0.2, {css:{height:0, width: 0}, ease: Power3.easeInOut})
    }


    const promos = content.map((promo, index) => {
   
        let promos = 
            <article  key={index} className={`col-6 col-md-4 col-lg-3 promo_single_animation ${classes.DynamicPagePromos__promo}`} >
                <div ref={el => promosMove.current[index] = el} className={classes.DynamicPagePromos__wrapAlign}>
                    {/* <div className={`first ${classes.DynamicPagePromos__promoHeader}`}> */}
                        <div ref={promoImage} onClick={(event) =>{ onPromoClick(promo.title); goToArticle(promo.url);}} className={`img_shadow ${classes.DynamicPagePromos__promoImage}`}
                            style={
                                {
                                    backgroundImage: 'url(' + getFileName(promosImages, promo.image) + ')'
                                }
                            } onMouseOver={() => overPromo(index)} onMouseOut={() => outPromo(index)}>
                        </div>
                        <h4 className={classes.DynamicPagePromos__promoTitle} onClick={(event) =>{ onPromoClick(promo.title); goToArticle(promo.url);}} onMouseOver={() => overPromo(index)} onMouseOut={() => outPromo(index)}>{promo.title}</h4>
                    <div ref={btnPromoOnHover} onClick={(event) =>{ onPromoClick(promo.title); goToArticle(promo.url);}} className={`hello  arrowCta ${classes.DynamicPagePromos__promoCta}`} onMouseOver={() => overPromo(index)} onMouseOut={() => outPromo(index)}>
                        <div className={`second ${classes.DynamicPagePromos__promoCtaWrapper}`}>
                            {promo.cta}
                            <span className={`arrowCta__iconWrapper ${classes.DynamicPagePromos__promoCtaIcon}`}>
                                <span ref={btnPromoArrowOnHover} className={`BB-${index} arrowCta__onHover`}></span>
                                <img ref={btnPromoOvalOnHover}  className={`AA-${index} arrowCta__oval`} alt="play icon border" src={getFileName(iconsImages, 'ovalArrow.svg')}/>
                                <img  className={`arrowCta__arrow`} alt="play icon" src={getFileName(iconsImages, 'nextArrow.svg')}/>
                            </span>
                        </div>
                    </div>
                </div>
            </article>
     
        return promos
        
    })
    
    return(
        // ref={carRef}
        <div className={classes.DynamicPagePromos } id='promo' >
            <div className={`${classes.DynamicPagePromos__bg}`}></div>
            <div className="container" ref={container}>
                <div ref={promosMoveCont} className={`row ${classes.DynamicPagePromos__header}`}>
                    <p className={classes.DynamicPagePromos__headerSubtitle}>{globalJson.dynamicPromos.subtitle}</p>
                    <h2 className={`col-8 col-md-12 ${classes.DynamicPagePromos__headerTitle}`}>
                        <span>{globalJson.dynamicPromos.title}</span>
                    </h2>
                </div>
                <div className={`row ${classes.DynamicPagePromos__promosContainer}`}>
                    {promos}
                </div>
            </div>
            
        </div>
    );
};
export default DynamicPagePromos;